export default "__VITE_ASSET__D8UKxC6O__"